const {queue} = require('../queue');
const notificationFactory = require('./notification.factory');
const StatusInfo = require('./status.info');
const tracking = require('./tracking');

const getBookingId = ({bookingId} = {}) => bookingId;

const toggleDownloadAppNotification = () => Odigeo.trigger('trip_details:toggleDownloadAppNotification');

const notificationType = 'cancellation';

class Manager {
    load({data = {}, keys = {}, callback = () => {}} = {}) {
        this.data = data;
        this.keys = keys;
        this.callback = callback;
        this.statusInfo = new StatusInfo({
            bookingId: getBookingId(data),
            keys: this.keys,
        });
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
        this.loadRefundStatus();
        this.promise.then(() => callback(notificationType));
    }

    loadRefundStatus() {
        return this.statusInfo.then((status) => this.processRefundStatus(status));
    }

    processRefundStatus(status = {}) {
        this.resolve(notificationType);
        queue.addNotification(notificationFactory.create({
            keys: this.keys,
            status,
            ctaHandler: toggleDownloadAppNotification,
            id: `cancelRequest-Voluntary-${this.statusInfo.bookingId}`,
        }));
        tracking.onLoadTracking(this.data, status);
        Odigeo.trigger('my_trips:processRefundStatus');
    }

    trackClick(status) {
        return () => tracking.onClickTracking(this.data, status);
    }
}

module.exports = new Manager();
